import { render, staticRenderFns } from "./DuwaViaTo.vue?vue&type=template&id=89401806"
import script from "./DuwaViaTo.vue?vue&type=script&lang=js"
export * from "./DuwaViaTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports